var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1146.5 1146.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M978.5 0H167.9C75.3 0 0 75.3 0 167.9v810.6c0 92.6 75.3 167.9 167.9 167.9H506V741.2H371.7V539.6h134.4V403.1c0-111.1 90.4-201.5 201.5-201.5h203.8v201.5H707.6v136.6h203.8l-33.6 201.5H707.6v405.3h270.9c92.6 0 167.9-75.3 167.9-167.9V167.9C1146.5 75.3 1071.1 0 978.5 0"
  })));
};
export default SvgFacebook;